export default function(biensLength = [], action) {
    
    if(action.type === "addLength"){
        biensLength.push(action.thisLength);
        return biensLength
    } else {
        return biensLength
    }
}